import React from 'react';

import useMatchTime from './useMatchTime';
import './matchTime.scss';

type OwnProps = {
    matchId: string;
    sportId: string;
};

const MatchTime = ({ matchId, sportId }: OwnProps) => {
    const { currentMatchPart, matchTimeToShow } = useMatchTime({
        matchId,
        sportId,
    });

    if (!matchTimeToShow && !currentMatchPart) return null;

    return (
        <div className="__app-MatchTime-container" styleName="container">
            {currentMatchPart && (
                <span className="__app-MatchTime-part" styleName="part">
                    {currentMatchPart}&nbsp;
                </span>
            )}
            {matchTimeToShow && (
                <span className="__app-MatchTime-time" styleName="time">
                    {matchTimeToShow}
                </span>
            )}
        </div>
    );
};

export default MatchTime;
